export const CProcedureStepsFragments = {
  field: `
    fragment procedureSteps on procedureSteps_MatrixField {
      ... on procedureSteps_block_Entry {
        id
        step {
          ... on step_Entry {
            id
            imageDesktop {
              url
              title
            }
            imageMobile {
              url
              title
            }
            video {
              url
              title
              embeddedAsset {
                url
                title
              }
            }
            heading
            description
            button2 {
              url
              target
              customText: label
              title
              text
              type
            }
            button1 {
              title
              customText: label
              target
              text
              url
              type
            }
            subheading
            stepperTitle
          }
        }
      }
    }
  `,
}
